import { Icons } from 'pages/Workshop/Icons';

export const transactionTypes = {
  MyTransactions: 'My Transactions',
  AllTransactions: 'All Transactions',
};

export const dropdownFields = [
  { itemValue: transactionTypes.MyTransactions, icon: Icons.USER },
  { itemValue: transactionTypes.AllTransactions, icon: Icons.TEAM_USER },
];

export const getDefaultValue = () => {
  return dropdownFields[1];
};
